var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 107,
    viewBox: "0 0 86 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.849609,
    y: 1.33008,
    width: 84.3,
    height: 105,
    rx: 3.5,
    stroke: "#475569"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 134.017,
    y2: -0.5,
    transform: "matrix(0.625639 0.780112 -0.862152 0.50665 1.07617 1.86719)",
    stroke: "#475569"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 134.017,
    y2: -0.5,
    transform: "matrix(0.625641 -0.780111 0.862151 0.506651 1.07617 106.416)",
    stroke: "#475569"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.1c5f9766ba3145fdf848ab873f737b79.svg";
export { ForwardRef as ReactComponent };